module.exports = __webpack_public_path__ + "img/prize3.9f93d42.png";